





























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PopupChangeStatus extends Vue {
  @Prop({ default: false }) readonly isDefault!: boolean;
  @Prop({ default: false }) readonly isLoading: boolean = false;
  @Prop({ default: false }) readonly typeChange: string;
}

